<template>
  <nav class="navbar relative flex items-center justify-between px-4 lg:px-20">
    <h2 class="flex items-center text-2xl uppercase font-bold text-cyma-purple">
      <RouterLink :to="{ name: 'index' }">
        CLIENTES
        <!-- <Logo class="h-10 w-auto text-cyma-purple" /> -->
      </RouterLink>
    </h2>
    <ul class="flex">
      <!-- <li
        v-for="item in menuItems"
        :key="item.routeName"
        class="p-5 text-cyma-purple text-base font-aileron"
      >
        <router-link
          :to="{
            name: item.routeName,
          }"
        >
          {{ item.title }}
        </router-link>
      </li> -->
      <li class="px-5 py-4">
        <ButtonLink :to="{ name: 'login' }">Iniciar sesión</ButtonLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import ButtonLink from '@/components/ButtonLink.vue';
import Logo from '@/components/Icons/Logo.vue';
// const menuItems = [
// { title: 'Inicio', routeName: 'index' },
// { title: 'Nosotros', routeName: 'about' },
// { title: 'Iniciar sesión', routeName: 'login' },
// { title: 'Sign up', routeName: 'signup' },
// ];
</script>
